import gql from 'graphql-tag'

export const PageInfoFragment = gql`
  fragment PageInfoFragment on PageInfo {
    endOffset
    hasNextPage
    hasPreviousPage
    startOffset
    totalItems
  }
`
